<template>
  <footer class="main-footer">
    <div class="content clearfix">
      <div class="left" > Copyright {{year}} <strong> Bioseco S.A.</strong>
      </div>
      <div class="right">
        <ul>
          <li><router-link to="/about">{{$t('footer.about')}}</router-link></li>
          <li><router-link to="/contact">{{$t('footer.contact')}}</router-link></li>
          <li><router-link to="/privacy-policy">{{$t('footer.privacy')}}</router-link></li>
          <li>
            <a href="https://www.facebook.com/Bioseco-497515667013273/" target="_blank" class="fb-icon"></a>
          </li>
          <li>
            <a href="https://pl.linkedin.com/company/bioseco/" target="_blank" class="linked-icon"></a>
          </li>
        </ul>
        <div class="logo">
          <span>{{$t('footer.created')}}</span>
          <span><img src="/static/img/soppo-logo.svg" alt="soppo-logo"></span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  var d = new Date();
  var rok = d.getFullYear();
  export default {

    name: 'footer-main',
    data() {
        return {year : rok}
    }
  }
</script>

<style scoped="">
  footer.main-footer .content .right ul li a{
    margin: 0 20px;
  }
</style>



// WEBPACK FOOTER //
// FooterMain.vue?4cc532ca